import * as type from './types';
import { createReducer } from "../../util/index";

//Set the initial state for the current page , current limit and current search values
const initialState = {
    data: []
};

const memberRegisterOriginReducer = createReducer(initialState) ({
    [type.GET_MEMBER_REGISTER_ORIGIN]: (state = initialState, action) => ({
        ...state,
       member_register_origin_data: action.payload
    }),
    [type.SHOW_MEMBER_REGISTER_ORIGIN_DETAILS]: (state = initialState, action) => ({
        ...state,
       show_member_register_origin_details_data: action.payload
    })
});

export default memberRegisterOriginReducer;